module.exports = __webpack_public_path__ + "static/copyhtml-94f835238101ed65875528a2f1f9378c.png";